"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _AssociationActionTypes = require("crm_schema/association/AssociationActionTypes");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _DealsAPI = require("crm_data/deals/api/DealsAPI");

var _definePooledObjectStore = require("crm_data/flux/definePooledObjectStore");

var _immutable = require("immutable");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _registerPooledObjectService = _interopRequireDefault(require("crm_data/flux/registerPooledObjectService"));

var PREFIX = 'DEALS';
(0, _registerPooledObjectService.default)({
  actionTypePrefix: PREFIX,
  fetcher: _DealsAPI.fetch
});
var DealsStore = (0, _definePooledObjectStore.definePooledObjectStore)({
  actionTypePrefix: PREFIX
}).defineResponseTo(_ActionTypes.DEAL_CREATED, function (state, deal) {
  var dealId = "" + deal.get('dealId');
  return state.set(dealId, deal);
}).defineResponseTo(_ActionTypes.DEALS_UPDATE_STARTED, function (state, _ref) {
  var id = _ref.id,
      nextProperties = _ref.nextProperties;

  if (!state.has(id)) {
    return state;
  }

  return state.updateIn([id], function (deal) {
    return nextProperties.reduce(function (acc, value, name) {
      return (0, _ImmutableModel.setProperty)(acc, name, value);
    }, deal);
  });
}).defineResponseTo(_ActionTypes.DEALS_UPDATE_SUCCEEDED, function (state, _ref2) {
  var id = _ref2.id,
      deal = _ref2.deal;
  return state.set(id, deal);
}).defineResponseTo(_ActionTypes.DEALS_UPDATE_FAILED, function (state, _ref3) {
  var id = _ref3.id,
      nextProperties = _ref3.nextProperties,
      properties = _ref3.properties;
  return state.updateIn([id], function (deal) {
    return properties.reduce(function (acc, value, name) {
      // don't overwrite changes made since the update began
      if (nextProperties.get(name) !== (0, _ImmutableModel.getProperty)(acc, name)) {
        return acc;
      }

      return (0, _ImmutableModel.setProperty)(acc, name, value);
    }, deal);
  });
}).defineResponseTo(_AssociationActionTypes.ASSOCIATE_COMPANY_AND_DEAL, function (state, _ref4) {
  var objectId = _ref4.objectId,
      subjectId = _ref4.subjectId;
  var dealId = "" + subjectId;

  if (!state.get(dealId)) {
    return state;
  }

  return state.setIn([dealId, 'associations', 'associatedCompanyIds'], _immutable.List.of(objectId));
}).defineResponseTo(_AssociationActionTypes.DISASSOCIATE_COMPANY_AND_DEAL, function (state, _ref5) {
  var subjectId = _ref5.subjectId;
  var dealId = "" + subjectId;

  if (!state.get(dealId)) {
    return state;
  }

  return state.setIn([dealId, 'associations', 'associatedCompanyIds'], (0, _immutable.List)());
}).defineResponseTo(_AssociationActionTypes.ASSOCIATE_CONTACT_AND_DEAL, function (state, _ref6) {
  var objectId = _ref6.objectId,
      subjectId = _ref6.subjectId;
  var dealId = "" + subjectId;

  if (!state.get(dealId)) {
    return state;
  }

  var path = [dealId, 'associations', 'associatedVids'];
  var associatedVids = state.getIn(path) || (0, _immutable.List)();

  if (!associatedVids.contains(objectId)) {
    associatedVids = associatedVids.push(objectId);
    state = state.setIn(path, associatedVids);
  }

  return state;
}).defineResponseTo(_AssociationActionTypes.DISASSOCIATE_CONTACT_AND_DEAL, function (state, _ref7) {
  var objectId = _ref7.objectId,
      subjectId = _ref7.subjectId;
  var dealId = "" + subjectId;

  if (!state.get(dealId)) {
    return state;
  }

  var path = [dealId, 'associations', 'associatedVids'];
  var associatedVids = state.getIn(path);
  var objectIdIndex = associatedVids.indexOf(objectId);

  if (objectIdIndex > -1) {
    associatedVids = associatedVids.remove(objectIdIndex);
    state = state.setIn(path, associatedVids);
  }

  return state;
}).register(_dispatcher.default);
var _default = DealsStore;
exports.default = _default;
module.exports = exports.default;